// removed by extract-text-webpack-plugin
module.exports = {"BotAvatarPreviewContainer":"BotAvatarPreviewContainer---24T__","BotAvatarPicker__Preview":"BotAvatarPicker__Preview---3fH7L","BotAvatarPicker__Loading":"BotAvatarPicker__Loading---3rBtl"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/settings/Routing/BotAvatarPreview/style.styl
// module id = N7zt
// module chunks = 89